import React, { useState, useEffect } from "react";
import { Card, Collapse, Button } from "react-bootstrap";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { APP_CONFIG } from "../../config/APP_CONFIG";
import ProtectedButton from "../RBAC/ProtectedButton";

const DeliveryHistory = ({
  userRole,
  selectedGroup,
  files,
  onAccept,
  setShowInitiateProjectModal,
  setShowProjectManagerModal,
  setShowMilestoneModal,
  setShowMilestonePaymentModal,
  setShowBuyerReviewModal,
  setShowRaiseFlagModal,
  milestone,
  setMilestone,
}) => {
  const [openHistory, setOpenHistory] = useState(true);
  const [openTeam, setOpenTeam] = useState(false);
  const [openFilesLinks, setOpenFilesLinks] = useState(false);
  const [milestoneNumber, setMilestoneNumber] = useState(0);

  const status = selectedGroup?.status;
  const statusOrder = selectedGroup?.statusOrder
  const milestones = selectedGroup?.milestones || [];
  const feedback = selectedGroup?.feedback || [];
  const teamMembers = selectedGroup?.users || [];

  const formatSize = (bytes) => {
    if (!bytes) return "";
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
    return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);

    // For recent completions (within 24 hours), show time only
    if (diffInHours < 24) {
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      });
    }

    // For older completions, show full date and time
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  };

  // Helper function to get timestamp for a step from statusHistory
  const getStepTimestamp = (step) => {
    const statusHistory = selectedGroup?.statusHistory;
    if (!statusHistory || !Array.isArray(statusHistory)) return null;

    // Find the statusHistory entry matching this step
    // Match by both status name and statusOrder for accuracy
    const historyEntry = statusHistory.find(
      h => h.status === step.status || h.statusOrder === step.statusOrder
    );

    return historyEntry?.updatedAt || null;
  };

  //---------Requirement Status Steps--------//
  // In Review
  // In Review + concern
  // Rejected
  // Seller Intimation


  //--------Seller Requiremnent Status Steps-------//
  // Seller Interested
  // Buyer Rejected
  // Buyer Interested
  // NDA Initiated
  // NDA Signed
  // Lost
  // Won


  const baseSteps = [
    { title: "NDA Signed", status: 'NDA Signed', statusOrder: 1 },
    { title: "Send RFQ", status: 'RFQ Sent', statusOrder: 2 }, // Proposal declined also 2
    { title: "Get Proposal", status: 'Proposal Sent', statusOrder: 3 },
    ...(statusOrder === 3.5 ? [{ title: "Project Rejected", status: 'Rejected', statusOrder: 3.5 }] : []), // only add when statusOrder is 3.5
    { title: "Accept Proposal", status: 'Proposal Accepted', statusOrder: 4 },
    { title: "Send PO Docs", status: 'Purchase Order Sent', statusOrder: 5 },
    { title: "Docs Ready", status: 'Documents Ready', statusOrder: 6 },
    { title: "Tripartite Agreement Initiated", status: 'Tripartite Agreement Initiated', statusOrder: 7 },
    { title: "Tripartite Agreement Signed", status: 'Tripartite Agreement Signed', statusOrder: 8 },
    { title: "PM Appointed", status: 'Project Manager Assigned', statusOrder: 9 },
    { title: "Contract Execution", status: 'Milestones Added', statusOrder: 10 },
  ];

  const milestoneSteps = (milestones || []).map((m, idx) => ({
    title: `Milestone ${idx + 1}`,
    status: `Milestones Completed + ${idx}`,
    statusOrder: 10 + (idx + 1) * 0.1,
    updatedAt: m.status === 'accept' ? m.updatedAt : null,
  }));

  const finalSteps = [
    ...baseSteps,
    ...(milestoneSteps.length > 0 ? milestoneSteps : [{ title: "Milestones", status: 'Milestones Completed', statusOrder: 11 }]),
    { title: "Feedback", status: 'Feedback Completed', statusOrder: 12 },
  ];

  const renderCircle = (step) => {
    if (step.statusOrder <= statusOrder + (milestoneNumber ? milestoneNumber * 0.1 - 0.1 : 0)) // done
      return (
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            border: "2px solid #2F54EB",
            background: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#2F54EB",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          ✓
        </div>
      );
    if (step.statusOrder == statusOrder + 1 + (milestoneNumber ? -1 + milestoneNumber * 0.1 : 0)) // current
      return (
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            background: "#FF4D4F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          ✕
        </div>
      );
    return (
      <div
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          border: "2px solid #D9D9D9",
          background: "#fff",
        }}
      />
    );
  };


  useEffect(() => {
    if (!milestones.length || statusOrder != 10) return;
    let number = 1;
    let foundMilestone;
    for (let i = 0; i < milestones.length; i++) {
      const m = milestones[i];
      if (m?.status === "accept") {
        number = number + 1;
        continue;
      } else {
        foundMilestone = m;
        break;
      }
    }

    setMilestoneNumber(number);

    // Also inform parent
    if (number <= milestones.length) {
      setMilestone({
        ...foundMilestone,
        milestoneNumber: number,
      });
    }
  }, [milestones, setMilestone]);

  // Compute button visibility
  const shouldShowButton =
    (userRole === "Buyer" && ["Purchase Order Sent", "Milestones Added"].includes(status)) ||
    (userRole === "Seller" && ["Milestones Added"].includes(status)) ||
    (userRole === "Admin" && ["Documents Ready", "Tripartite Agreement Signed"].includes(status)) ||
    (userRole === "Project Manager" && ["Project Manager Assigned"].includes(status)) ||
    (userRole === "Buyer" && ["Milestones Completed"].includes(status) && !feedback.includes('buyer')) ||
    (userRole === "Seller" && ["Milestones Completed"].includes(status) && !feedback.includes('seller')) ||
    (userRole === "Project Manager" && ["Milestones Completed"].includes(status) && !feedback.includes('pm'));

  // Show "Raise a Flag" button for PM during execution phase
  const shouldShowRaiseFlagButton =
    userRole === "Project Manager" && statusOrder >= 10 && statusOrder <= 11;

  // Button click handler
  const handleButtonClick = () => {
    if (userRole === "Buyer" && status === "Purchase Order Sent")
      return onAccept();
    if (userRole === "Admin" && status === "Documents Ready")
      return setShowInitiateProjectModal(true);
    if (userRole === "Admin" && status === "Tripartite Agreement Signed")
      return setShowProjectManagerModal(true);
    if (userRole === "Project Manager" && status === "Project Manager Assigned")
      return setShowMilestoneModal(true);
    if (userRole === "Buyer" && status === "Milestones Added")
      return setShowMilestonePaymentModal(true);
    if (userRole === "Seller" && status === "Milestones Added")
      return window.open(`${APP_CONFIG.ESCROW_URL}/transaction/${milestone.transactionId}`, '_blank')
    if (userRole === "Buyer" && status === "Milestones Completed" && !feedback.includes('buyer'))
      return setShowBuyerReviewModal(true);
    if (userRole === "Seller" && status === "Milestones Completed" && !feedback.includes('seller'))
      return setShowBuyerReviewModal(true);
    if (userRole === "Project Manager" && status === "Milestones Completed" && !feedback.includes('pm'))
      return setShowBuyerReviewModal(true);
  };

  // ✅ Button label
  const buttonLabel =
    (userRole === "Buyer" && status === "Purchase Order Sent" && "Confirm Documents Ready") ||
    (userRole === "Admin" && status === "Documents Ready" && "Initiate Project") ||
    (userRole === "Admin" && status === "Tripartite Agreement Signed" && "Appoint Project Manager") ||
    (userRole === "Project Manager" && status === "Project Manager Assigned" && "Add Milestones") ||
    (userRole === "Buyer" && status === "Milestones Added" && milestone.status === "create" && `Accept Milestone ${milestoneNumber}`) ||
    (userRole === "Buyer" && status === "Milestones Added" && milestone.status === "agree" && `Pay Milestone ${milestoneNumber}`) ||
    (userRole === "Buyer" && status === "Milestones Added" && ["payment_sent", "payment_approved", "ship", "receive"].includes(milestone.status) && `Accept Milestone Delivery ${milestoneNumber}`) ||
    (userRole === "Seller" && status === "Milestones Added" && milestone.status === "create" && `Agree To Transaction ${milestoneNumber}`) ||
    (userRole === "Seller" && status === "Milestones Added" && ["agree", "payment_sent"].includes(milestone.status) && `Accept Milestone Payment ${milestoneNumber}`) ||
    (userRole === "Seller" && status === "Milestones Added" && ["payment_approved", "ship", "receive"].includes(milestone.status) && `Submit Milestone ${milestoneNumber}`) ||
    (userRole === "Buyer" && status === "Milestones Completed" && !feedback.includes('buyer') && "Feedback") ||
    (userRole === "Seller" && status === "Milestones Completed" && !feedback.includes('seller') && "Feedback") ||
    (userRole === "Project Manager" && status === "Milestones Completed" && !feedback.includes('pm') && "Feedback") ||
    "";

  const permission =
    (userRole === "Buyer" && status === "Purchase Order Sent" && "confirmDocumentsReady") ||
    (userRole === "Admin" && status === "Documents Ready" && "initiateProject") ||
    (userRole === "Admin" && status === "Tripartite Agreement Signed" && "appointProjectManager") ||
    (userRole === "Project Manager" && status === "Project Manager Assigned" && "addMilestones") ||
    (userRole === "Buyer" && status === "Milestones Added" && `payMilestone`) ||
    (userRole === "Seller" && status === "Milestones Added" && `approveMilestone`) ||
    (userRole === "Buyer" && status === "Milestones Completed" && !feedback.includes('buyer') && "feedback") ||
    (userRole === "Seller" && status === "Milestones Completed" && !feedback.includes('seller') && "feedback") ||
    (userRole === "Project Manager" && status === "Milestones Completed" && !feedback.includes('pm') && "feedback") ||
    "";

  return (
    <div className="d-flex flex-column h-100">
      {/* ===== Action Button ===== */}
      {shouldShowButton && (
        <ProtectedButton
          permission={permission}
          variant="dark"
          onClick={handleButtonClick}
          className="mb-3"
          style={{
            backgroundColor: "#0E144E",
            color: "#fff",
            fontSize: "15px",
            fontWeight: "500",
            border: "none",
            borderRadius: "8px",
            padding: "10px 24px",
            lineHeight: "1.2",
            transition: "all 0.2s ease-in-out",
          }}
        >
          {buttonLabel}
        </ProtectedButton>
      )}

      {/* ===== Raise a Flag Button (PM Only, Execution Phase) ===== */}
      {shouldShowRaiseFlagButton && (
        <ProtectedButton
          permission="raiseFlag"
          variant="danger"
          onClick={() => setShowRaiseFlagModal(true)}
          className="mb-3"
          style={{
            backgroundColor: "#DC2626",
            color: "#fff",
            fontSize: "15px",
            fontWeight: "500",
            border: "none",
            borderRadius: "8px",
            padding: "10px 24px",
            lineHeight: "1.2",
            transition: "all 0.2s ease-in-out",
          }}
        >
          🚩 Raise a Flag
        </ProtectedButton>
      )}

      {/* ===== Delivery History Card ===== */}
      <div className="h-100">
        <Card className="shadow-sm mb-2">
          <Card.Body
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", padding: "10px 15px" }}
            onClick={() => setOpenHistory(!openHistory)}
          >
            <div className="d-flex align-items-center">
              <img src="/images/menu.svg" alt="menu" />
              <strong>Delivery history</strong>
            </div>
            {openHistory ? <FaChevronDown /> : <FaChevronRight />}
          </Card.Body>
        </Card>

        <Collapse in={openHistory}>
          <div className="ps-4 position-relative">
            <div
              style={{
                position: "absolute",
                top: "12px",
                bottom: "15px",
                left: "36px",
                transform: "translateX(-50%)",
                width: "2px",
                background: "#E0E0E0",
              }}
            />
            {finalSteps.map((step, i) => {
              const timestamp = step.updatedAt ? step.updatedAt : getStepTimestamp(step);
              const formattedDate = timestamp ? formatDate(timestamp) : null;

              return (
                <div
                  key={i}
                  className="d-flex align-items-start mb-3 position-relative"
                >
                  <div style={{ marginRight: "12px" }}>{renderCircle(step)}</div>
                  <div>
                    <p className="mb-0 fw-semibold" style={{ fontSize: "14px", color: "#000" }}>
                      {step.title}
                    </p>
                    {formattedDate && (
                      <small className="text-muted" style={{ fontSize: "12px" }}>
                        {formattedDate}
                      </small>
                    )}
                  </div>
                  <img
                    src="/images/info.svg"
                    alt="info"
                    className="ms-auto"
                    style={{ marginTop: "2px" }}
                  />
                </div>
              );
            })}
          </div>
        </Collapse>

        {/* ===== Team Card ===== */}
        <Card className="shadow-sm mb-2">
          <Card.Body
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", padding: "10px 15px" }}
            onClick={() => setOpenTeam(!openTeam)}
          >
            <div className="d-flex align-items-center">
              <img src="/images/team.svg" alt="team" />
              <strong>Team</strong>
            </div>
            {openTeam ? <FaChevronDown /> : <FaChevronRight />}
          </Card.Body>
          <Collapse in={openTeam}>
            <div className="px-3 pb-3">
              {teamMembers.length === 0 ? (
                <div className="text-muted small px-2">No team members found</div>
              ) : (
                <ul className="list-unstyled mb-0">
                  {teamMembers.map((member, idx) => (
                    <li
                      key={member._id || member.userId || idx}
                      className="d-flex align-items-center py-2 border-bottom"
                    >
                      {member.profilePic ? (
                        <img
                          src={member.profilePic}
                          alt={member.name}
                          className="rounded-circle me-3"
                          width="32"
                          height="32"
                        />
                      ) : (
                        <div
                          className="rounded-circle text-white d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: 32,
                            height: 32,
                            fontWeight: "bold",
                            fontSize: "14px",
                            backgroundColor: "#0E144E",
                          }}
                        >
                          {member.name?.charAt(0).toUpperCase() || "?"}
                        </div>
                      )}
                      <div>
                        <div className="fw-semibold" style={{ fontSize: "14px" }}>
                          {member.name}
                        </div>
                        <div className="text-muted" style={{ fontSize: "12px" }}>
                          {member.role || "Team Member"}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </Collapse>
        </Card>

        {/* ===== Files & Links Card ===== */}
        <Card className="shadow-sm mb-3 border-0 rounded-4">
          <Card.Body
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", padding: "12px 18px" }}
            onClick={() => setOpenFilesLinks(!openFilesLinks)}
          >
            <div className="d-flex align-items-center gap-2">
              <img src="/images/files.svg" alt="files" width={22} />
              <strong className="text-dark">Files & Links</strong>
            </div>
            {openFilesLinks ? <FaChevronDown /> : <FaChevronRight />}
          </Card.Body>

          <Collapse in={openFilesLinks}>
            <div className="px-3 pb-3">
              {files.length === 0 ? (
                <div className="text-muted small px-2">No files uploaded yet</div>
              ) : (
                <ul className="list-unstyled mb-0">
                  {files.map((file) => (
                    <li key={file._id} className="border rounded-3 p-3 mb-2 bg-light">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          {file.fileUrl?.startsWith("http") ? (
                            <Link
                              to={file.fileUrl}
                              target="_blank"
                              className="fw-semibold text-decoration-none text-primary"
                            >
                              {file.fileName}
                            </Link>
                          ) : (
                            <span className="fw-semibold">{file.fileName}</span>
                          )}
                          {file.description && (
                            <div className="text-muted small">{file.description}</div>
                          )}
                        </div>
                      </div>
                      <div className="text-muted small mt-1">
                        <br />• By{" "}
                        <strong>
                          {file.senderId?.name} ({file.senderId?.role || "User"} Team)
                        </strong>
                        <br />• File Size: {formatSize(file.fileSize)}
                        <br />• Uploaded At: {formatDate(file.createdAt)}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </Collapse>
        </Card>
      </div>
    </div>
  );
};

export default DeliveryHistory;
